/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import Vue from 'vue'
import { init, trackClick } from '@spfe/hawkeye-js-sdk'
import dayjs from 'dayjs'

interface Properties {
  [key: string]: any
}

// 神策替换为百度统计 + matomo
// 兼容原有神策埋点事件
export const hawkeyeInit = async () => {
  init({
    // 可根据域名获取
    appKey: '',
    // 是否开启 hash 路由追踪
    enableHashRouteTracking: false
  })
  // 公共属性与用户属性
  const properties: Properties = {}

  const hawkeye = {
    $login(id: number) {
      properties.loginId = id
    },
    $quick() {},
    // 注册公共属性
    $registerPage(data: Properties) {
      Object.assign(properties, data)
    },
    // 设置用户属性
    $setProfile() {
      // 暂不处理
    },
    $pageview() {},
    $webClick() {},
    $webStay() {},
    // 事件收集
    $track(category: string, label: Properties, value: string) {
      try {
        const _label = JSON.stringify(
          Object.assign(
            properties,
            {
              page_name: document.title,
              page_url: location.href,
              operating_time: dayjs().format('YYYY-MM-DD HH:mm')
            },
            label
          )
        )
        trackClick(category, _label, value)
      } catch (error) {}
    }
  }

  window.Hawkeye = window.Hawkeye ? window.Hawkeye : hawkeye

  Vue.prototype.$hawkeye = window.Hawkeye
}
